import { createContext, useContext, useState, useEffect } from 'react'
import { applyStatusBarForTheme } from '../lib/statusBar'

const ThemeContext = createContext(null)

const GOLF_THEMES = ['light', 'classic', 'bold']

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try { return localStorage.getItem('golf_theme') || 'light' } catch { return 'light' }
  })

  useEffect(() => {
    document.documentElement.setAttribute('data-golf-theme', theme)
    try { localStorage.setItem('golf_theme', theme) } catch {}
    // F-001-T4e: keep the native Android status-bar icons readable against the
    // active theme (dark icons on light/bold, light icons on classic). Native-
    // gated no-op on web. Runs at init and on every theme change.
    applyStatusBarForTheme(theme)
  }, [theme])

  const setGolfTheme = (t) => {
    if (GOLF_THEMES.includes(t)) setTheme(t)
  }

  const cycle = () => {
    const i = GOLF_THEMES.indexOf(theme)
    setTheme(GOLF_THEMES[(i + 1) % GOLF_THEMES.length])
  }

  return (
    <ThemeContext.Provider value={{ theme, setGolfTheme, cycle, themes: GOLF_THEMES }}>
      {children}
    </ThemeContext.Provider>
  )
}

export function useTheme() {
  return useContext(ThemeContext)
}
